import { useContext } from 'react';

import { NuDsContext } from '../../components/NuDSProvider/NuDSProvider';
import intlAriaAttrs from '../intl/intlAriaAttrs';

export default function useIntlAriaAttrs({ intlAriaKey }) {
  const nudsContext = useContext(NuDsContext);
  return intlAriaAttrs(nudsContext, intlAriaKey);
}
